import { Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Skeleton } from 'primeng/skeleton';

export type KlLoadingSkeletonVariant = 'table' | 'stack' | 'compact';

@Component({
  selector: 'kl-loading-skeleton',
  standalone: true,
  imports: [Skeleton, TranslateModule],
  templateUrl: './kl-loading-skeleton.html',
  styleUrl: './kl-loading-skeleton.scss',
})
export class KlLoadingSkeletonComponent {
  readonly variant = input<KlLoadingSkeletonVariant>('stack');
  readonly rows = input(8);
  readonly columns = input(4);
  readonly lines = input(6);
  readonly compactRows = input(3);
  /** i18n key for screen-reader-only status text */
  readonly announceKey = input('loading');
  readonly announceSr = input(true);

  readonly rowIndexes = computed(() => Array.from({ length: this.rows() }, (_, i) => i));
  readonly colIndexes = computed(() => Array.from({ length: this.columns() }, (_, i) => i));
  readonly lineIndexes = computed(() => Array.from({ length: this.lines() }, (_, i) => i));
  readonly compactIndexes = computed(() => Array.from({ length: this.compactRows() }, (_, i) => i));

  colWidth(i: number): string {
    const w = ['22%', '32%', '18%', '14%'];
    return w[i % w.length];
  }

  cellWidth(i: number): string {
    const w = ['20%', '36%', '16%', '12%'];
    return w[i % w.length];
  }

  stackLineWidth(i: number): string {
    const pattern = ['92%', '78%', '65%', '88%', '70%'];
    return pattern[i % pattern.length];
  }

  compactWidth(i: number): string {
    const pattern = ['100%', '85%', '65%'];
    return pattern[i % pattern.length];
  }
}
